import { render, staticRenderFns } from "./AuthTokenSection.vue?vue&type=template&id=19d4af5c&scoped=true&"
import script from "./AuthTokenSection.vue?vue&type=script&lang=js&"
export * from "./AuthTokenSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19d4af5c",
  null
  
)

export default component.exports